import React from 'react'
import { useTranslation } from "react-i18next";
import { getAssetUrl } from '../../../utils/assetUtils';

const CardTr = (props) => {
    const { t } = useTranslation();

    const card = props.card;
    const openModal = props.openModal;
    const openImageModal = props.openImageModal;
    const cardNumber = props.cardNumber;
    const confirmPackage = props.confirmPackage;

    return (
        <>
            <tr>
                <td>{card.image_url && <img src={getAssetUrl(card.image_url)} alt="" onClick={openImageModal}/>}</td>
                <td>{card.package_name}</td>
                <td>{card.name}{card.is_psa_enabled == 1 && `(PSA${card.psa})`}
                </td>
                {card.rank == 9 ?
                    <>
                    <td>{t('tr.num')}</td>
                    </>
                :
                <>
                    <td>{card.rank}{t('tr.rank')}</td>
                </>
                }
            </tr>
        </>
    )
}

export default CardTr